<div class="container">
    <h2 mat-dialog-title>View Termination</h2>

    <div mat-dialog-content class="dialog-content">
        <div class="termination-details">
            <div class="detail-row">
                <span class="label">Merchant ID:</span>
                <span class="value">{{ data.terminationRecord.merchantId }}</span>
            </div>
            <div class="detail-row">
                <span class="label">Status:</span>
                <span class="value">{{ data.terminationRecord.status }}</span>
            </div>
            <div class="detail-row">
                <span class="label">Created At:</span>
                <span class="value">{{ data.terminationRecord.createdAt | date }}</span>
            </div>
            <div class="detail-row">
                <span class="label">Created By:</span>
                <span class="value">{{ data.terminationRecord.createdByDisplay }}</span>
            </div>
            <div class="detail-row">
                <span class="label">Decisioned At:</span>
                <span class="value">{{ data.terminationRecord.decisionedAt | date }}</span>
            </div>
            <div class="detail-row">
                <span class="label">Decisioned By:</span>
                <span class="value">{{ data.terminationRecord.decisionedByDisplay }}</span>
            </div>
        </div>
    </div>

    <div class="form-actions" mat-dialog-actions>
        <button mat-flat-button class="close" (click)="close()">
            Close
        </button>
    </div>
</div>
